import request from 'Request'

const UploadService = {
  async uploadHeader({ formData }) {
    return request.post('/upload/header', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  async uploadResource({ formData }) {
    return request.post('/upload/resource', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default UploadService
